module.exports = __webpack_public_path__ + "static/media/ic_small_arrow_right.ac3e01be.svg";